import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const SERVICE_NAME = "PresentationNotesPageService";
const log: any = LoggerModule.getInstance();

export class PresentationNotesPageService {
  private static instance: PresentationNotesPageService;
  private vapp: VApplication;
  private criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): PresentationNotesPageService {
    if (!PresentationNotesPageService.instance) {
      PresentationNotesPageService.instance = new PresentationNotesPageService(props);
    }
    return PresentationNotesPageService.instance;
  }

  public getStaticPageContent() {
    const agent = getAgent();
    return agent.getStaticPageContentSync({});
  }

  public async getPageContent(args: any) {
    let content: any = {};
    const agent = getAgent();

    const headerProps = await agent.getHeaderProps();
    if (headerProps) {
      content = { ...content, header: headerProps };
    }

    const listProps = await agent.getPresentationListProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (listProps) {
      content = { ...content, ...listProps };
    }

    return content;
  }

  public async updateNote(args: { id: string; note: string }) {
    const agent = getAgent();
    return agent.updateNote(args);
  }
}
